import { mfaErrorKey, type MfaErrorKey } from '@/http/queries/mfaError';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { Alert } from '@eye-able/ui';

export type MfaErrorOverrides = Partial<Record<MfaErrorKey, MfaErrorKey>>;

/** Explains a failed second-factor request; nothing while there is none. */
function MfaErrorAlert({
  error,
  id,
  overrides,
}: {
  error: unknown;
  id?: string;
  /** Another wording for a key where the default would mislead (a dead proof is not a dead login). */
  overrides?: MfaErrorOverrides;
}) {
  const { t } = useInlineTranslation();
  if (!error) return null;
  const key = mfaErrorKey(error);
  return (
    <Alert variant='error' role='alert' id={id}>
      {t(overrides?.[key] ?? key)}
    </Alert>
  );
}

export default MfaErrorAlert;
